<template>
  <span
    ref="link"
    class="d-user-link-popup"
  >
    <span
      class="content"
      @mouseover="showPopup"
      @mouseleave="stopLoading"
      @click.capture="contentClickPrevent"
    >
      <slot name="content" />
    </span>

    <MountingPortal
      v-if="isPopupShown && shouldDisplayPopup"
      mount-to="#portal-container"
      append
    >
      <DUserInfoPopup
        v-if="isPopupShown && shouldDisplayPopup"
        :in-modal="inModal"
        :link="$refs.link"
        :user-info="userInfo"
        @close-popup="closePopup"
      />
    </MountingPortal>
  </span>
</template>

<script>
import Vue from 'vue';

import DUserInfoPopup from './d-user-info-popup/d-user-info-popup.vue';
import popupService from '@d-services/popup-service/popup-service';
import { getErrorMessage } from '@d-shared/utils/errors';
import { debounce } from '@dui/helpers/util-funcs';
import { DEBOUNCE_TIME } from '@d-shared/config';
import SASS from '@dui/helpers/sass';

export default {
  components: {
    DUserInfoPopup,
  },
  props: {
    inModal: {
      type: Boolean,
      default: false,
    },
    shouldDisplayPopup: {
      type: Boolean,
      default: true,
    },
    userId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    cancelled: false,
    isLoading: false,
    isPopupShown: false,
    isAccountClosed: false,
    userInfo: null,
  }),
  methods: {
    closePopup() {
      this.$set(this, 'isPopupShown', false);
    },
    contentClickPrevent(e) {
      if (window.innerWidth >= SASS.screenSize.lg) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
    },
    showPopup() {
      this.$set(this, 'cancelled', false);
      window.innerWidth < SASS.screenSize.lg ? this.loadUserInfo() : this.debounceLoad();
    },
    debounceLoad: debounce(function() {
      this.loadUserInfo();
    }, DEBOUNCE_TIME.normal),
    async loadUserInfo() {
      if (this.isLoading || this.isPopupShown || !this.shouldDisplayPopup || this.cancelled) {
        return;
      }

      this.$set(this, 'isLoading', true);

      try {
        const userInfo = await popupService.getUserForPopup(this.userId);
        this.$set(this, 'userInfo', userInfo);
        this.$set(this, 'isPopupShown', true);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // Ignore error as we want to show popup for deactivated accounts
          this.$set(this, 'isPopupShown', true);
        } else {
          Vue.duiNotificationManager.error(getErrorMessage(error));
        }
      }

      this.$set(this, 'isLoading', false);
    },
    stopLoading() {
      this.$set(this, 'cancelled', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

$width-desktop-popup: 320px;

.d-user-link-popup {
  display: inline-flex;
  flex: none;
  overflow: visible;
  position: relative;

  & a {
    position: relative;
  }
}
</style>
